import _ from "lodash";
/** external */
import React from "react";
import { StatementOfInquiryDuotone } from "@toddle-edu/ds-icons";
import { Checkbox, RadioButton } from "@toddle-edu/ds-web";
import classNames from "classnames";
import { getIconList } from "GenericTableEditor/IconPicker/IconPickerUtils";

/** internal */
import { useI18n } from "Hooks";

/** relative */
import classes from "./Card.scss";

const Card = props => {
  const {
    label,
    subtext,
    icon,
    showIcon,
    isSelected,
    showSubtext,
    isSingleSelect,
  } = props;

  const { t } = useI18n(["common"]);

  const containerClasses = classNames(classes.container, {
    [classes.activeContainer]: isSelected,
  });

  const labelClasses = classNames(
    "text-label-3",
    _.isEmpty(label) && classes.emptyFieldDataset
  );
  const subtextClasses = classNames(
    "text-body-3",
    classes.subtext,
    _.isEmpty(subtext) && classes.emptyFieldDataset
  );

  const iconName = _.get(icon, "metadata.iconName", "");
  const iconURL = _.get(icon, "url", "");

  const iconList = getIconList();

  const labelToDisplay =
    label ??
    t("common:label_not_filled", {
      label: t("common:title"),
    });

  return (
    <div className={containerClasses}>
      <div className={classes.contentContainer}>
        {showIcon ? (
          icon ? (
            iconURL ? (
              <img
                src={iconURL}
                className={classes.icon}
                alt={labelToDisplay}
              />
            ) : (
              <div className={classes.icon}>
                {_.get(iconList[iconName], "component")}
              </div>
            )
          ) : (
            <div className={classes.icon}>
              <StatementOfInquiryDuotone hasBackground={true} />
            </div>
          )
        ) : null}

        <div className={classes.detailsContainer}>
          <div className={labelClasses}>{labelToDisplay}</div>
          {showSubtext ? (
            <div className={subtextClasses}>
              {subtext
                ? subtext
                : t("common:label_not_filled", {
                    label: t("common:descriptor"),
                  })}
            </div>
          ) : null}
        </div>
      </div>

      {isSingleSelect ? (
        <RadioButton checked={isSelected} />
      ) : (
        <Checkbox isChecked={isSelected} />
      )}
    </div>
  );
};

export default Card;
